import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react';
import styles from '../hoa/hoa.module.css';
import Slide from '../slide/customized-slide';

const Routes = require('../../routes').Routes;

function MyRedDog() {
  const data = useStaticQuery(
    graphql`
      query {
        background: file(relativePath: { eq: "bg/bg_hoa.png" }) {
          childImageSharp {
            fluid(quality: 90, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        image: file(relativePath: { eq: "reddog/reddog.png" }) {
          childImageSharp {
            fluid(maxWidth: 1500, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  );

  const backgroundImageData = data.background.childImageSharp.fluid;
  const imageData = data.image.childImageSharp.fluid;

  return (
    <Slide
      title="Building LLM-based chatbot for property owners"
      text="Brocoders helped CIA Services, a management company for homeowners associations, deliver an LLM-based chatbot integrated into a mobile app to make it easier for property owners to access community information and property data."
      caseLink={Routes.CASE_STUDIES_HOA_MANAGMENT}
      backgroundImageData={backgroundImageData}
      imageData={imageData}
      bgColor="#23366b"
      btnClassName={styles.button}
      imageClassName={styles.image}
    />
  );
}

export default MyRedDog;
